import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import DefaultLayout from '../components/DefaultLayout'
import { Row, Col, Form, Tabs, Input, Button, Select, DatePicker } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { editExpense } from '../redux/actions/expenseAction'
import moment from 'moment';

const { TabPane } = Tabs;

const { Option } = Select;

function EditExpense({ match }) {

  const { expense } = useSelector(state => state.expenseReducer)

  const ex = expense.find(sc => sc._id == match.params.id)
  const allsites = useSelector(state => state.sitesReducer).sites;

  const [expenseInfo, setExpenseInfo] = useState({})
  const [activeTab, setActiveTab] = useState("0")

  const dispatch = useDispatch()
  const allworkers = useSelector(state => state.workersReducer).workers;
  const history = useHistory()

  function onFinalFormFinish(values) {
    const finalObj = { ...expenseInfo, ...values };

    finalObj._id = match.params.id
    console.log(finalObj)
    dispatch(editExpense(finalObj))
  }

  return (
    <div>
      <DefaultLayout>
        <Tabs defaultActiveKey='0' activeKey={activeTab}>
          <TabPane tab='Edit Expense' key='0'>
            <Form onFinish={onFinalFormFinish} onReset={() => { history.push('/postedExpenses') }} >
              <Row>
                <Col lg={8} sm={24}>
                  <div>
                    <Form.Item name='appliedCandidate' label='Select Employees' valuePropName="option" initialValue={ex.appliedCandidate}>
                      <Select
                        defaultValue={ex.appliedCandidate}
                        className="mr-2"
                        style={{ minWidth: 200 }}

                      >
                        <Option value="0" disabled>-- Select Employee --</Option>
                        {allworkers.map(worker => {
                          return <Option value={worker.fname} key={worker.fname} >{worker.fname}</Option>
                        })}
                      </Select>
                    </Form.Item>

                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='date' rules={[{ required: true }]} label='Date' initialValue={moment(new Date(ex.date), 'dddd, MMMM Do YYYY')}>
                    <DatePicker
                      format='dddd, MMMM Do YYYY'
                      defaultValue={moment(new Date(ex.date), 'dddd, MMMM Do YYYY')}
                      style={{ width: 380 }}
                      className="mr-2"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='worksite' rules={[{ required: true }]} label='Worksite' initialValue={ex.worksite} >
                    <Select
                      defaultValue={'0'}
                      className="mr-2"
                      style={{ minWidth: 200 }}
                    >
                      <Option value="0" disabled>-- Select Worksite --</Option>
                      {allsites.map(site => {
                        return <Option value={site.siteName} key={site['_id']} >{site.siteName}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='expense' rules={[{ required: true }]} label='Expense' initialValue={ex.expense} >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='type' label='Type' rules={[{ required: true }]} >
                    <Select
                      defaultValue={ex.type}
                      className="mr-2"
                      style={{ minWidth: 200 }}
                    >
                      <Option value="0" disabled>-- Select Type --</Option>
                      <Option value="Travel">Travel</Option>
                      <Option value="Lodging">Lodging</Option>
                      <Option value="Food">Food</Option>
                      <Option value="Equipment">Equipment</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>


              <Button htmlType='submit'>Submit</Button>
              <Button htmlType='reset' type="default" danger className="ml-2">Cancel</Button>
            </Form>
          </TabPane>

        </Tabs>
      </DefaultLayout>
    </div>
  )
}

export default EditExpense
